import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, Button, Form, Badge } from 'react-bootstrap';
import { UserContext } from '../../Context/UserContext';
import { notify } from 'react-notify-toast';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faTrashAlt,
  faGraduationCap,
  faChalkboardTeacher,
  faCalendarAlt,
  faClock,
  faSave,
  faSlidersH,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { ClassroomList } from '../../Context/ClassroomListContext';
import CampusEnrollment from './CampusEnrollment';
import QuillEditor from './QuillEditor';
import Autocomplete from './Autocomplete';
import clientAxios from '../../clients/clientAxios';
import moment from 'moment';
import 'moment/locale/es';
import './commission.css';

moment.locale('es');

const MAX_QUOTA_OVERRIDE_FIELD = 'maxQuotaCourseOverride';

export default function Info({ mentorList, commission, setCommission, searchMentors }) {
  const { updateClassRoomList } = useContext(ClassroomList);
  const [changes, setChanges] = useState(false);
  const [courses, setCourses] = useState([]);
  const [courseSearch, setCourseSearch] = useState('');
  const [isCourseOptionsOpen, setIsCourseOptionsOpen] = useState(false);
  const [activeCourseIndex, setActiveCourseIndex] = useState(-1);
  const [showCampusEnrollment, setShowCampusEnrollment] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const user = useContext(UserContext);
  const [plans, setPlans] = useState(null);
  const [carreers, setCarreers] = useState(null);

  const getCourses = async () => {
    try {
      const { data } = await clientAxios('/courses');
      setCourses(data);
    } catch (error) {
      notify.show('Error al cargar los cursos', 'error');
    }
  };

  useEffect(() => {
    getCourses();
  }, []);

  const [scheduleCopy, setScheduleCopy] = useState({
    schedule: [
      {
        day: '',
        since: '',
        to: '',
      },
    ],
  });

  const history = useHistory();
  const headerConfig = {
    headers: { 'auth-token': localStorage.getItem('JWT') || ' ' },
  };

  const updateCommission = async (obj) => {
    if (obj) {
      obj.preventDefault();
    }
    if (courseSearch.trim()) {
      notify.show('Seleccione un curso de la lista', 'error');
      return;
    }
    if (!commission.schedule || commission.schedule.length === 0) {
      commission.schedule = scheduleCopy.schedule;
    }

    try {
      setIsSubmitting(true);
      const { data } = await clientAxios.put(
        `/classroom/edit/${commission._id}`,
        { commission, changes },
        headerConfig
      );

      if (data.success) {
        notify.show(data.message, 'success');
        setChanges(false);
        updateClassRoomList();
      } else {
        notify.show(data.message, 'error');
      }
    } catch (err) {
      notify.show(err?.response?.data?.message || 'Error al actualizar comisión', 'error');
      history.push('/');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (obj, index, origin) => {
    let { name, value } = obj.target;
    if (name === 'helper' && !value) {
      value = null;
    }
    if (name === 'carreer' && value === '') {
      value = null;
    }
    if (name === MAX_QUOTA_OVERRIDE_FIELD) {
      value = value ? parseInt(value, 10) : undefined;
    }
    if (name === 'course') {
      setChanges(true);
    }

    if (origin) {
      if (origin === 'schedule') {
        let scheduleLet = [...(commission.schedule || [])];
        scheduleLet[index] = { ...scheduleLet[index], [name]: value };
        setCommission({ ...commission, schedule: scheduleLet });
      } else if (origin === 'copy') {
        let scheduleCopyLet = [...scheduleCopy.schedule];
        scheduleCopyLet[index] = { ...scheduleCopyLet[index], [name]: value };
        setScheduleCopy({ ...scheduleCopy, schedule: scheduleCopyLet });
      }
    } else {
      setCommission({ ...commission, [name]: value });
    }
    setChanges(true);
  };

  const handleQuillEdit = (value) => {
    setCommission((prev) => ({
      ...prev,
      courseSummary: value,
    }));
    setChanges(true);
  };

  const enrollToCourse = () => {};

  const addDaytoSchedule = (type) => {
    if (type === 'schedule') {
      let schedulePropCopy = [...(commission.schedule || [])];
      schedulePropCopy.push({
        day: '',
        since: '',
        to: '',
      });
      setCommission({ ...commission, schedule: schedulePropCopy });
    } else if (type === 'copy') {
      let scheduleCopyState = [...scheduleCopy.schedule];
      scheduleCopyState.push({
        day: '',
        since: '',
        to: '',
      });
      setScheduleCopy({ ...scheduleCopy, schedule: scheduleCopyState });
    }
    setChanges(true);
  };

  const deleteDaytoSchedule = (indexS, type) => {
    if (type === 'schedule') {
      let schedulePropCopy = [...(commission.schedule || [])];
      schedulePropCopy.splice(indexS, 1);
      setCommission({ ...commission, schedule: schedulePropCopy });
    } else if (type === 'copy') {
      let scheduleCopyState = [...scheduleCopy.schedule];
      scheduleCopyState.splice(indexS, 1);
      setScheduleCopy({ ...scheduleCopy, schedule: scheduleCopyState });
    }
    setChanges(true);
  };

  const getMentorOrHelperName = (id) => {
    if (!id) {
      return '';
    }
    if (typeof id === 'object') {
      if (id.firstName || id.lastName) {
        const firstName = id.firstName || '';
        const lastName = id.lastName || '';
        return `${firstName} ${lastName}`.trim();
      }
      if (id.name) {
        return id.name;
      }
      const nestedId = id._id || id.id;
      if (!nestedId) {
        return '';
      }
      const nestedMentor = mentorList?.find(
        (m) => (m._id || m.id) === nestedId
      );
      if (nestedMentor) {
        if (nestedMentor.firstName || nestedMentor.lastName) {
          return `${nestedMentor?.firstName || ''} ${nestedMentor?.lastName || ''}`.trim();
        }
        return nestedMentor?.name || '';
      }
      return '';
    }
    const mentor = mentorList?.find((m) => (m._id || m.id) === id);
    if (!mentor) {
      return '';
    }
    if (mentor.firstName || mentor.lastName) {
      return `${mentor?.firstName || ''} ${mentor?.lastName || ''}`.trim();
    }
    return mentor?.name || '';
  };

  const getPlans = async () => {
    try {
      const { data } = await clientAxios(`/planes/`);
      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getCarreers = async () => {
    try {
      const { data } = await clientAxios(`/carreers/`);
      setCarreers(data);
    } catch (error) {
      notify.show('Hubo un inconveniente recuperando carreras', 'error');
    }
  };

  useEffect(() => {
    getCarreers();
  }, []);

  useEffect(() => {
    if (commission) {
      getPlans();
    }
    //eslint-disable-next-line
  }, []);

  if (user && user.level >= 3) {
    return null;
  }

  const activeSchedules =
    commission.schedule && commission.schedule.length !== 0
      ? commission.schedule
      : scheduleCopy.schedule;
  const scheduleType =
    commission.schedule && commission.schedule.length !== 0
      ? 'schedule'
      : 'copy';
  const selectedCourseName =
    commission.course && typeof commission.course === 'object'
      ? commission.course.name
      : commission.course || '';
  const filteredCourses = courses.filter((course) =>
    course.name.toLowerCase().includes(courseSearch.trim().toLowerCase())
  );

  const selectCourse = (course) => {
    handleChange({ target: { name: 'course', value: course.name } });
    setCourseSearch('');
    setIsCourseOptionsOpen(false);
    setActiveCourseIndex(-1);
  };

  const handleCourseKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setIsCourseOptionsOpen(true);
      setActiveCourseIndex((currentIndex) =>
        currentIndex < 0
          ? 0
          : Math.min(currentIndex + 1, filteredCourses.length - 1)
      );
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setIsCourseOptionsOpen(true);
      setActiveCourseIndex((currentIndex) =>
        currentIndex < 0
          ? filteredCourses.length - 1
          : Math.max(currentIndex - 1, 0)
      );
    } else if (
      event.key === 'Enter' &&
      isCourseOptionsOpen &&
      filteredCourses.length > 0
    ) {
      event.preventDefault();
      selectCourse(filteredCourses[activeCourseIndex] || filteredCourses[0]);
    } else if (event.key === 'Escape') {
      setCourseSearch('');
      setIsCourseOptionsOpen(false);
      setActiveCourseIndex(-1);
    }
  };

  return (
    <div className='commission-card p-4'>
      <CampusEnrollment
        show={showCampusEnrollment}
        onHide={() => setShowCampusEnrollment(!showCampusEnrollment)}
        updateCommission={commission}
        enrollToCourse={enrollToCourse}
      />

      <div className='d-flex align-items-center justify-content-between pb-3 border-bottom mb-4'>
        <div className='d-flex align-items-center'>
          <div
            className='mr-2 rounded-circle d-flex align-items-center justify-content-center'
            style={{
              width: 36,
              height: 36,
              backgroundColor: '#f0fdf4',
              color: '#16a34a',
            }}
          >
            <FontAwesomeIcon icon={faSlidersH} />
          </div>
          <div>
            <h5 className='mb-0 font-weight-bold text-dark'>Configuración de la Comisión</h5>
            <small className='text-muted'>Detalles, docentes, planes y horarios</small>
          </div>
        </div>
        {changes && (
          <Badge variant='warning' className='px-2 py-1'>
            Cambios sin guardar
          </Badge>
        )}
      </div>

      <Form onSubmit={updateCommission}>
        {/* Section 1: Course and General Details */}
        <div className='commission-section-card'>
          <div className='commission-section-title'>
            <FontAwesomeIcon icon={faGraduationCap} className='text-primary' />
            Curso y Modalidad
          </div>

          <div className='custom-control custom-switch mb-3'>
            <input
              type='checkbox'
              className='custom-control-input'
              id='isRollingKidSwitch'
              name='isRollingKid'
              checked={commission.isRollingKid || false}
              onChange={(e) => {
                setCommission({
                  ...commission,
                  isRollingKid: e.target.checked,
                });
                setChanges(true);
              }}
            />
            <label className='custom-control-label font-weight-bold text-dark' htmlFor='isRollingKidSwitch'>
              Comisión Rolling Kids
            </label>
          </div>

          <Row>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label
                  className='commission-form-label'
                  htmlFor='commission-course'
                >
                  Curso *
                </Form.Label>
                <div className='search-bar-container'>
                  <Form.Control
                    id='commission-course'
                    type='text'
                    name='course'
                    className='commission-input'
                    placeholder='Buscar un curso...'
                    value={
                      isCourseOptionsOpen ? courseSearch : selectedCourseName
                    }
                    onChange={(event) => {
                      setCourseSearch(event.target.value);
                      setIsCourseOptionsOpen(true);
                      setActiveCourseIndex(-1);
                    }}
                    onFocus={() => {
                      setCourseSearch('');
                      setIsCourseOptionsOpen(true);
                      setActiveCourseIndex(-1);
                    }}
                    onBlur={() => {
                      setIsCourseOptionsOpen(false);
                      setActiveCourseIndex(-1);
                    }}
                    onKeyDown={handleCourseKeyDown}
                    role='combobox'
                    aria-autocomplete='list'
                    aria-expanded={isCourseOptionsOpen}
                    aria-controls='commission-course-options'
                    aria-activedescendant={
                      activeCourseIndex >= 0 &&
                      filteredCourses[activeCourseIndex]
                        ? `commission-course-option-${activeCourseIndex}`
                        : undefined
                    }
                    required
                  />
                  {isCourseOptionsOpen && (
                    <div
                      id='commission-course-options'
                      className='list-group suggestions-list'
                      role='listbox'
                    >
                      {filteredCourses.length > 0 ? (
                        filteredCourses.map((course, index) => (
                          <button
                            id={`commission-course-option-${index}`}
                            key={course._id}
                            type='button'
                            className={`list-group-item list-group-item-action${
                              index === activeCourseIndex ? ' active' : ''
                            }`}
                            role='option'
                            aria-selected={index === activeCourseIndex}
                            onMouseDown={(event) => event.preventDefault()}
                            onClick={() => selectCourse(course)}
                          >
                            {course.name}
                          </button>
                        ))
                      ) : (
                        <div
                          className='list-group-item text-muted'
                          role='option'
                          aria-disabled='true'
                        >
                          No se encontraron cursos.
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Carrera</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name='carreer'
                  className='commission-input'
                  value={
                    commission?.carreer
                      ? commission?.carreer
                      : commission &&
                        Object.keys(commission).length === 0 &&
                        carreers?.length > 0
                      ? carreers[0]?._id
                      : ''
                  }
                  as='select'
                >
                  <option value=''>Sin carrera</option>
                  {carreers?.map((carreer, index) => (
                    <option key={`${index}carreer`} value={carreer?._id}>
                      {carreer?.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Modalidad *</Form.Label>
                <Form.Control
                  as='select'
                  name='mode'
                  className='commission-input'
                  value={commission?.mode || 'Online'}
                  onChange={handleChange}
                  required
                >
                  <option value='Online'>Online</option>
                  <option value='Presencial'>Presencial</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Sede</Form.Label>
                <Form.Control
                  as='select'
                  name='officeLocation'
                  className='commission-input'
                  value={commission?.officeLocation || ''}
                  onChange={handleChange}
                >
                  <option value=''>Seleccione una sede...</option>
                  <option value='Tucumán'>Tucumán</option>
                  <option value='Buenos Aires'>Buenos Aires</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className='mb-0'>
            <Form.Label className='commission-form-label'>Descripción del Curso</Form.Label>
            <div className='bg-white rounded border'>
              <QuillEditor
                onChange={handleQuillEdit}
                value={commission.courseSummary}
              />
            </div>
          </Form.Group>
        </div>

        {/* Section 2: Mentors and Plans */}
        <div className='commission-section-card'>
          <div className='commission-section-title'>
            <FontAwesomeIcon icon={faChalkboardTeacher} className='text-info' />
            Equipo Docente y Finanzas
          </div>

          <Row>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Mentor a cargo *</Form.Label>
                <Autocomplete
                  name='mentor'
                  dataSourge={mentorList}
                  commission={commission}
                  setCommission={setCommission}
                  setChanges={setChanges}
                  value={getMentorOrHelperName(commission.mentor)}
                  onSearch={searchMentors}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Tutor / Ayudante</Form.Label>
                <Autocomplete
                  name='helper'
                  dataSourge={mentorList}
                  commission={commission}
                  setCommission={setCommission}
                  setChanges={setChanges}
                  value={getMentorOrHelperName(commission.helper)}
                  onSearch={searchMentors}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Plan de Pago Carrera *</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  autoComplete='on'
                  name='plan'
                  className='commission-input'
                  value={commission?.plan || ''}
                  as='select'
                  required
                >
                  <option value='' hidden>
                    Seleccione un plan de carrera...
                  </option>
                  {plans?.map((plan) => {
                    if (!plan?.specialPlan) {
                      return (
                        <option
                          key={plan?._id}
                          value={plan?._id}
                        >
                          {plan?.name} {plan?.description}
                        </option>
                      );
                    }
                    return null;
                  })}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Plan Curso Individual</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  autoComplete='on'
                  name='planCourseSingle'
                  className='commission-input'
                  value={commission?.planCourseSingle || ''}
                  as='select'
                >
                  <option value='' hidden>
                    Seleccione un plan individual...
                  </option>
                  {plans?.map((plan, index) => {
                    if (!plan?.specialPlan) {
                      return (
                        <option key={index} value={plan._id}>
                          {plan?.name} {plan?.description}
                        </option>
                      );
                    }
                    return null;
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </div>

        {/* Section 3: Status and Channels */}
        <div className='commission-section-card'>
          <div className='commission-section-title'>
            <FontAwesomeIcon icon={faCalendarAlt} className='text-success' />
            Estado, Canales y Fechas
          </div>

          <Row>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Canal de Slack</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name='slackChannel'
                  className='commission-input'
                  placeholder='ej. #comision-react-2026'
                  value={commission.slackChannel || ''}
                  type='text'
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Estado de la Comisión</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name='isActive'
                  className='commission-input'
                  value={commission.isActive || ''}
                  as='select'
                >
                  <option value='' hidden>
                    Seleccione estado...
                  </option>
                  <option value='active'>Activo</option>
                  <option value='done'>Finalizada</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Publicación</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name='published'
                  className='commission-input'
                  value={
                    commission?.published === undefined
                      ? ''
                      : commission.published
                  }
                  as='select'
                >
                  <option value='' hidden>
                    Seleccione visibilidad...
                  </option>
                  <option value={true}>Publicada</option>
                  <option value={false}>No publicada</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Fecha de inicio</Form.Label>
                <Form.Control
                  type='date'
                  className='commission-input'
                  value={
                    commission?.initialDate &&
                    moment(commission.initialDate, 'YYYY-MM-DD').format(
                      'YYYY-MM-DD'
                    )
                  }
                  defaultValue={commission?.initialDate || ''}
                  name='initialDate'
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label className='commission-form-label'>Cupo Máximo</Form.Label>
                <Form.Control
                  type='number'
                  className='commission-input'
                  placeholder='Cupo de alumnos'
                  value={commission?.[MAX_QUOTA_OVERRIDE_FIELD] ?? ''}
                  name={MAX_QUOTA_OVERRIDE_FIELD}
                  min={0}
                  step={1}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>

        {/* Section 4: Schedule and Times */}
        <div className='commission-section-card'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div className='commission-section-title mb-0'>
              <FontAwesomeIcon icon={faClock} className='text-warning' />
              Días y Horarios de Cursada
            </div>
            <Button
              variant='outline-primary'
              size='sm'
              onClick={() => addDaytoSchedule(scheduleType)}
              className='d-inline-flex align-items-center'
            >
              <FontAwesomeIcon icon={faPlus} className='mr-1' />
              Añadir Día
            </Button>
          </div>

          {activeSchedules.map((day, index) => (
            <div key={index} className='schedule-row-item'>
              <Row className='align-items-center'>
                <Col xs={12} sm={4} className='mb-2 mb-sm-0'>
                  <Form.Group className='mb-0'>
                    <Form.Label className='commission-form-label small'>Día</Form.Label>
                    <Form.Control
                      onChange={(e) => handleChange(e, index, scheduleType)}
                      name='day'
                      value={day.day}
                      as='select'
                      size='sm'
                      className='commission-input'
                      required
                    >
                      <option hidden value=''>
                        Elige un día...
                      </option>
                      <option value='monday'>Lunes</option>
                      <option value='tuesday'>Martes</option>
                      <option value='wednesday'>Miércoles</option>
                      <option value='thursday'>Jueves</option>
                      <option value='friday'>Viernes</option>
                      <option value='saturday'>Sábados</option>
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col xs={6} sm={3}>
                  <Form.Group className='mb-0'>
                    <Form.Label className='commission-form-label small'>Desde</Form.Label>
                    <Form.Control
                      onChange={(e) => handleChange(e, index, scheduleType)}
                      name='since'
                      value={day.since}
                      type='time'
                      size='sm'
                      className='commission-input'
                      max={day.to}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xs={6} sm={3}>
                  <Form.Group className='mb-0'>
                    <Form.Label className='commission-form-label small'>Hasta</Form.Label>
                    <Form.Control
                      onChange={(e) => handleChange(e, index, scheduleType)}
                      name='to'
                      value={day.to}
                      type='time'
                      size='sm'
                      className='commission-input'
                      min={day.since}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xs={12} sm={2} className='text-right mt-2 mt-sm-0'>
                  {index >= 1 ? (
                    <Button
                      variant='outline-danger'
                      size='sm'
                      className='schedule-action-btn'
                      title='Eliminar día'
                      onClick={() => deleteDaytoSchedule(index, scheduleType)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} size='sm' />
                    </Button>
                  ) : (
                    <Button
                      variant='outline-primary'
                      size='sm'
                      className='schedule-action-btn'
                      title='Añadir día'
                      onClick={() => addDaytoSchedule(scheduleType)}
                    >
                      <FontAwesomeIcon icon={faPlus} size='sm' />
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          ))}
        </div>

        {/* Submit Action Bar */}
        <div className='d-flex align-items-center justify-content-between pt-3 border-top mt-3'>
          <div className='text-muted small'>
            {!commission?.students ? (
              <span className='text-muted'>
                <FontAwesomeIcon icon={faInfoCircle} className='mr-1' />
                Selecciona una comisión para editar sus datos
              </span>
            ) : (
              <span>Los cambios se aplicarán inmediatamente al guardar</span>
            )}
          </div>

          <Button
            variant='primary'
            type='submit'
            className='px-4 py-2 font-weight-bold shadow-sm'
            disabled={!commission?.students || isSubmitting}
          >
            <FontAwesomeIcon icon={faSave} className='mr-2' />
            {isSubmitting ? 'Guardando...' : 'Actualizar datos'}
          </Button>
        </div>
      </Form>
    </div>
  );
}
